import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeDeleteMedicationMutation as useDeDeleteMedicationMutationType } from "@/modules/patients/detail/medication/de/services/__generated__/useDeDeleteMedicationMutation.graphql"

const mutation = graphql`
  mutation useDeDeleteMedicationMutation($input: De_deleteMedicationInput!, $connections: [ID!]!) {
    de_deleteMedication(input: $input) {
      de_Medication {
        id @deleteEdge(connections: $connections)
        ...deMedicationFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeDeleteMedicationMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeDeleteMedicationMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeDeleteMedicationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeDeleteMedicationMutation }
